import type { Mark } from '../document-types';
import type { MarkHandler } from './types';

export class StrikeMark implements MarkHandler {
  readonly type = 'strike';

  apply(text: string, _mark: Mark): string {
    return `~~${text}~~`;
  }
}
